enum CountryEnum {
    SOUTH_AFRICA = "South Africa"
}


export {
    CountryEnum
}